import { defineContent, type DefinedContent } from '@post-office/define-content';

export const registeredContent: DefinedContent<{
	default: [
		'heading',
		'subheadingJira',
		'subheadingConfluence',
		'appTilesAlt',
		'ctaButton',
		'closeLabel',
	];
	personalized: [
		'heading',
		'subheadingJira',
		'subheadingConfluence',
		'subheadingLoom',
		'ctaButton',
		'closeLabel',
	];
}> = defineContent({
	default: {
		heading: {
			id: 'twc.sidenav.banner.generic.heading',
			defaultMessage: 'Explore Teamwork Collection',
			description: 'Main heading for the generic TWC activation banner in the product sidenav.',
			role: 'title',
		},
		subheadingJira: {
			id: 'twc.sidenav.banner.generic.subheading.jira',
			defaultMessage: 'Discover how the other apps can accelerate your workflows in Jira.',
			description: 'Subheading for the generic banner when shown in Jira.',
			role: 'description',
		},
		subheadingConfluence: {
			id: 'twc.sidenav.banner.generic.subheading.confluence',
			defaultMessage: 'Discover how the other apps can accelerate your workflows in Confluence.',
			description: 'Subheading for the generic banner when shown in Confluence.',
		},
		appTilesAlt: {
			id: 'twc.sidenav.banner.generic.app.tiles.alt',
			defaultMessage: 'App tiles illustration',
			description: 'Alt text for the app tiles illustration in the generic banner.',
		},
		ctaButton: {
			id: 'twc.sidenav.banner.generic.cta',
			defaultMessage: 'Try now',
			description: 'CTA button text for the generic TWC activation banner in the product sidenav.',
		},
		closeLabel: {
			id: 'twc.sidenav.banner.generic.close',
			defaultMessage: 'Close',
			description: 'Accessible label for the close button on the generic TWC activation banner.',
		},
	},
	personalized: {
		heading: {
			id: 'twc.sidenav.banner.personalized.heading',
			defaultMessage: 'Explore Teamwork Collection',
			description:
				'Main heading for the personalized missing-app activation banner in the product sidenav.',
			role: 'title',
		},
		subheadingJira: {
			id: 'twc.sidenav.banner.personalized.subheading.jira',
			defaultMessage: 'Plan your next team project in Jira',
			description:
				'Personalized banner subheading when the recommended app is Jira. Shown in the product sidenav.',
			role: 'description',
		},
		subheadingConfluence: {
			id: 'twc.sidenav.banner.personalized.subheading.confluence',
			defaultMessage: 'Create with Rovo in Confluence',
			description:
				'Personalized banner subheading when the recommended app is Confluence. Shown in the product sidenav.',
		},
		subheadingLoom: {
			id: 'twc.sidenav.banner.personalized.subheading.loom',
			defaultMessage: 'Record meetings with Loom, get instant notes and actions.',
			description:
				'Personalized banner subheading when the recommended app is Loom. Shown in the product sidenav.',
		},
		ctaButton: {
			id: 'twc.sidenav.banner.personalized.cta',
			defaultMessage: 'Get started',
			description:
				'CTA button text for the personalized missing-app activation banner in the product sidenav.',
		},
		closeLabel: {
			id: 'twc.sidenav.banner.personalized.close',
			defaultMessage: 'Close',
			description:
				'Accessible label for the close button on the personalized missing-app activation banner.',
		},
	},
});
